import { EyeOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { useTheme } from "../../../../Context/ThemeContext";
import BiddingDetailsModal from "./BiddingDetailsModal";
import Search from "antd/es/input/Search";

const BiddingTable = () => {
  const { themeData } = useTheme();
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);

  const dataSource = [
    {
      key: "1",
      bidName: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      bidName: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Bid Id",
      dataIndex: "bidId",
      key: "bidId",
      width: "10%",
    },
    {
      title: "Bid Name",
      dataIndex: "bidName",
      key: "bidName",
    },
    {
      title: "Bid Start Date",
      dataIndex: "bidStartDate",
      key: "bidStartDate",
    },
    {
      title: "Bid Submit Date",
      dataIndex: "bidSumbitDate",
      key: "bidSumbitDate",
    },
    {
      title: "Bid Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      render: () => (
        <>
          <Space>
            <Button
              style={{ padding: "1px 5px" }}
              onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <EyeOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        <div>
          <Row>
            <Col>
              <Search />
            </Col>
          </Row>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Table
            dataSource={dataSource}
            columns={columns}
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
          />
        </div>
      </Card>

      {isModelOpen && (
        <BiddingDetailsModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
        />
      )}
    </>
  );
};

export default BiddingTable;
